import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/user/login",
    name: "login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/user/register",
    name: "register",
    component: () => import("../views/register.vue"),
  },
  {
    path: "/user/reset-pass",
    name: "reset-pass",
    component: () => import("../views/reset-pass.vue"),
  },
  {
    path: "/toResetEmail",
    name: "toResetEmail",
    component: () => import("../views/toResetEmail.vue"),
  },
  {
    path: "/user/bindAccount",
    name: "bindAccount",
    component: () => import("../views/bind-account.vue"),
  },
  {
    path: "/user/emileBind",
    name: "emileBind",
    component: () => import("../views/emile-bind.vue"),
  },
  {
    path: "*",
    mame: "not-page",
    component: () => import("../views/404.vue"),
  },
  {
    path: "/user/edit-pass",
    name: "edit-pass",
    component: () => import("../views/edit-pass.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
